<template>
<div class="fluid-container">
  <div class="hello row">
      <div class="col-1 col-md-1"></div>
      <div class="col-11 col-md-4 infoDiv">
        <h1 class="titre">Brigida Bocini</h1>
        <p class="infos">Studio: Usine Parker, rue Jacques-Grosselin 50 C, 1227 Carouge, CH</p>
        <a href="mailto:brigidabocini@gmail.com">Contact</a><br><br>
      </div>
      <div class="col-md-1 d-sm-none d-md-block hiddenBlock"></div>
      <div class="w-100 d-md-none hiddenBlock"></div>
      <div class="col-1 d-md-none"></div>
      <div class="col-11 col-md-5">

        <table>
          <tbody>
            <tr>
              <td class="year"><h1 class="latest">Latest</h1></td>
            </tr>
            <tr>
              <td class="year">2020</td>
              <td class="cell"><a class="linkExpo" target="_blank" href="https://fcac.ch/actualites/bourses-deliees-arts-visuels-2020-2/"><i>Bourses Déliées 2020</i>, Fonds cantonal d’art contemporain (FCAC),
        Halle nord, Geneva</a></td>
            </tr>
            <tr>
              <td class="year">2020</td>
              <td class="cell"><a href="https://www.sculpturegarden.ch/events/" target="_blank" class="linkExpo"><i>Sans chemise, sans pantalon </i>(w. Sylvain Gelewski), Musée sans batiment by Yona Friedman, Sculpture Garden, Geneva Biennale, CH</a></td>
            </tr>
          </tbody>
        </table>
      </div>

  </div>
</div>
</template>

<script>
export default {
  name: 'HelloWorld2',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
